import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.css']
})
export class ProductosComponent implements OnInit {

  productosForm = new UntypedFormGroup({
    busquedaFormControl: new UntypedFormControl(null),
    numeroAerovaleFormControl: new UntypedFormControl(null),
  });

  constructor() { }

  ngOnInit() {
  }



}
